import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import "../styles/BookingSuccess.css";

const BookingCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="booking-success-page">
      <Navigation />
      
      <div className="success-container">
        <div className="status-card cancel">
          <XCircle size={80} color="#f59e0b" />
          <h1 className="heading-1">Booking Cancelled</h1>
          <p className="body-large">            Your booking was cancelled and no payment was processed.
          </p>
          
          <p className="body-regular" style={{marginTop: "20px"}}>            If you'd like to try again, please select your preferred service and time.
          </p>

          <button onClick={() => navigate("/")} className="btn-primary" style={{marginTop: "30px"}}>            <ArrowLeft size={20} /> Back to Home
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BookingCancelPage;